import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function CustomCursor() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const moveCursor = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", moveCursor);
    return () => window.removeEventListener("mousemove", moveCursor);
  }, []);

  return (
    <motion.div
      className="fixed top-0 left-0 w-6 h-6 pointer-events-none z-10 mix-blend-difference"
      animate={{
        x: position.x - 12,
        y: position.y - 12,
        scale: isHovering ? [1, 1.2, 1.4, 1.2] : 1,
        rotate: isHovering ? [0, 10, -10, 5, -5, 0] : 0,
        borderRadius: isHovering ? "50%" : "10px",
        background: isHovering
          ? "radial-gradient(circle, #00F0FF, #0F0E9E)"
          : "radial-gradient(circle, #38bdf8, #6366f1)",
        boxShadow: isHovering
          ? "0 0 25px rgba(0, 240, 255, 0.9), 0 0 35px rgba(15, 14, 158, 0.5)"
          : "0 0 10px rgba(56, 189, 248, 0.8)",
        opacity: isHovering ? 0.9 : 0.8,
      }}
      transition={{
        type: "tween",
        ease: "easeOut",
        duration: 0.25,
      }}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    />
  );
}
